import { MessageCircle } from 'lucide-react'

import { cn } from '@/lib/utils'

interface ChatLauncherProps {
  hasUnread?: boolean
  onClick: () => void
  /** Hide on small screens (e.g. when the floating save bar is shown). */
  mobileHidden?: boolean
}

export function ChatLauncher({
  hasUnread,
  onClick,
  mobileHidden
}: ChatLauncherProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Open chat"
      className={cn(
        'app-chrome fixed bottom-5 right-5 z-[1000] h-14 w-14 items-center justify-center rounded-full border-0 bg-primary text-white shadow-[0_8px_24px_rgba(17,173,187,0.45)] outline-none transition-transform hover:scale-105 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 active:scale-95',
        mobileHidden ? 'hidden sm:flex' : 'flex'
      )}
    >
      <MessageCircle className="h-6 w-6" />
      {hasUnread && (
        <span className="absolute right-1 top-1 flex h-3.5 w-3.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-destructive opacity-75" />
          <span className="relative inline-flex h-3.5 w-3.5 rounded-full border-2 border-white bg-destructive" />
        </span>
      )}
    </button>
  )
}
